import React, { useState, useRef, useEffect } from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup'
import Button from 'react-bootstrap/Button'
import Table from 'react-bootstrap/Table'
import Spinner from 'react-bootstrap/Spinner'
import Alert from 'react-bootstrap/Alert'

import { toast } from 'react-toastify'

import api from 'api/api'
import './cargos.css'
import { debounce } from 'utils/debounce'
import Paginacion from 'components/Paginacion'
import NuevoCargoDirectiva from './NuevoCargoDirectiva'
import DeleteCargoDirectiva from './DeleteCargoDirectiva'
import VerCargoDirectiva from './VerCargoDirectiva'
import EditarCargoDirectiva from './EditarCargoDirectiva'

function CargosDirectiva() {
	const [fetchDeACuantos, setFetchDeACuantos] = useState(10)
	const [numResultados, setNumResultados] = useState(0)
	const [paginaAct, setPaginaAct] = useState(1)
	const [loading, setLoading] = useState(false)

	const [busqueda, setBusqueda] = useState('')
	const [filtroBusqueda, setFiltroBusqueda] = useState('')
	const [cargos, setCargos] = useState([])
	const [cargoActual, setCargoActual] = useState()
	const [queMostrar, setQueMostrar] = useState('')


	const refreshCargos = async () => {
		try {
			setLoading(true)
			const { datos } = await api.post('p/ver-cargos-directiva', {
				cuantos: fetchDeACuantos,
				desde: paginaAct === 1 ? 0 : (paginaAct - 1) * fetchDeACuantos,
				filtros: {
					nombre: [filtroBusqueda],
				}
			})

			setCargos(datos.cargos)
			setNumResultados(datos.numResultados)
		} catch (error) {
			toast.error('Error de conexión')
			console.error(error)
		} finally {
			setLoading(false)
		}
	}

	const handleBusqueda = (value) => {
		if (value) {
			setFiltroBusqueda(value)
		} else {
			setFiltroBusqueda('')
		}
	}

	const debouceFiltroBusqueda = React.useCallback(
		debounce(handleBusqueda, 400),
		[]
	)

	useEffect(() => {
		debouceFiltroBusqueda(busqueda)
	}, [busqueda])

	useEffect(() => {
		if (paginaAct === 1) {
			refreshCargos()
		} else {
			setPaginaAct(1)
		}
	}, [filtroBusqueda, fetchDeACuantos])

	useEffect(() => {
		if (!loading) {
			refreshCargos()
		}
	}, [paginaAct])

	const opcionesCuantosMostrar = [10, 25, 50]

	const handleAction = (cargo, cual) => {
		setCargoActual(cargo, setQueMostrar(cual))
	}

	const nuevoCargo = async (data) => {
		const enviar = { ...data }

		try {
			const { msg } = await api.post('a/cargos-directiva', enviar)
			refreshCargos()
			setQueMostrar('')
			toast.success(msg)
		} catch (error) {
			console.error(error)
			toast.error('Error de conexión')
		}
	}

	const editarCargo = async (data) => {
		const enviar = { ...data }

		try {
			const { msg } = await api.put('a/cargos-directiva/' + data.id, enviar)
			refreshCargos()
			setQueMostrar('')
			toast.success(msg)
		} catch (error) {
			console.error(error)
			toast.error('Error de conexión')
		}
	}

	const eliminarCargo = async (id) => {
		const { msg } = await api.delete('a/cargos-directiva/' + id)
		refreshCargos()
		setQueMostrar('')
		toast.success(msg)
	}

	// render
	return (
		<Container fluid id="cargos-directiva" className="vh-100">
			<Row className="d-flex no-gutters">
				<Col className="mt-2">
					<Form>
						<Row id="searchbar" className="justify-content-between align-items-center">
							<Col sm={6} md={3} style={{ display: 'block' }}>
								<small>
									<span className="d-none d-sm-inline-block">Mostrar de a</span>
									<Form.Group className="mb-3" style={{ display: 'inline-block' }}>
										<Form.Select size="sm" onChange={(e) => setFetchDeACuantos(e.target.value)} className="mx-1">
											{opcionesCuantosMostrar.map((o) => {
												return (
													<option value={o} key={`mostrar-${o}`}>
														{o}
													</option>
												)
											})}
										</Form.Select>
									</Form.Group>
									<span className="ms-2">cargos</span>
								</small>
							</Col>
							<Col md={5} lg={4}>
								<Form.Group controlId="txtBusqueda">
									<InputGroup>
										<Form.Control
											autoFocus
											value={busqueda}
											onChange={(e) => setBusqueda(e.target.value)}
											type="text"
											placeholder="Buscar"
											aria-label="Buscar"
										/>
										<InputGroup.Text><Form.Label className="mb-0"><i className="fa fa-search"></i></Form.Label></InputGroup.Text>
									</InputGroup>
								</Form.Group>
							</Col>
						</Row>
					</Form>
				</Col>
			</Row>
			<Row className="d-flex no-gutters justify-content-between align-items-end mt-2">
				<Col>
					<Button onClick={() => setQueMostrar('nuevo')} variant="primary">
						<i className="fa fa-plus"></i> Nuevo cargo
					</Button>
				</Col>
				<Col className="text-end">
					<small>Total resultados: <strong>{numResultados}</strong></small>
				</Col>
			</Row>
			{/* Table */}
			<Row>
				<Col>
					<Table id="tabla-cargos-directiva" className="mt-2" bordered hover>
						<thead>
							<tr>
								<th>Id</th>
								<th>Cargo</th>
								<th>Orden</th>
								<th>Acciones</th>
							</tr>
						</thead>
						<tbody>
							{loading ? (
								<tr>
									<td colSpan="4">
										<Spinner
											animation="border"
											size="lg"
											role="status"
											aria-hidden="true"
											variant="primary"
											className="my-3"
										/>
									</td>
								</tr>
							) : (
								cargos.length === 0 ? (
									<tr>
										<td colSpan="4">
											<Alert variant="info">No se encontraron cargos de la Comisión Directiva</Alert>
										</td>
									</tr>
								) : (
									cargos.map((cargo, index) => {
										return (
											<tr key={cargo.id}>
												<td>{cargo.id}</td>
												<td>{cargo.nombre}</td>
												<td>{cargo.orden || '-'}</td>
												<td>
													<Button
														onClick={() => handleAction(cargo, 'ver')}
														className="me-2"
														variant="primary"
													>
														<i className="fa fa-eye"></i>
													</Button>
													<Button
														onClick={() => handleAction(cargo, 'editar')}
														className="me-2"
														variant="secondary"
													>
														<i className="fa fa-pencil"></i>
													</Button>
													<Button
														onClick={() => handleAction(cargo, 'eliminar')}
														variant="danger"
													>
														<i className="fa fa-trash"></i>
													</Button>
												</td>
											</tr>
										)
									})
								)
							)}
						</tbody>
					</Table>
				</Col>
			</Row>
			<Row>
				<Col>
					<Paginacion
						pagina={paginaAct}
						numPaginas={Math.ceil(numResultados / fetchDeACuantos) || 1}
						setPagina={setPaginaAct}
					/>
				</Col>
			</Row>
			{/* Panel Nuevo */}
			{queMostrar === 'nuevo' && (
				<NuevoCargoDirectiva
					guardar={nuevoCargo}
					setQueMostrar={setQueMostrar}
				/>
			)}
			{/* Panel Ver */}
			{cargoActual && queMostrar === 'ver' &&
				<VerCargoDirectiva
					cargo={cargoActual}
					setQueMostrar={setQueMostrar}
				/>
			}
			{/* Panel Editar */}
			{cargoActual && queMostrar === 'editar' &&
				<EditarCargoDirectiva
					cargoOriginal={cargoActual}
					setQueMostrar={setQueMostrar}
					guardar={editarCargo}
				/>
			}
			{/* Modal Delete */}
			{
				cargoActual &&
				<DeleteCargoDirectiva
					cargo={cargoActual}
					mostrar={queMostrar === 'eliminar'}
					setQueMostrar={setQueMostrar}
					eliminarCargo={eliminarCargo}
				/>
			}
		</Container>
	)
}

export default CargosDirectiva